"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChipSpinner = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _Spinner = require("../Spinner/Spinner");
var _VisuallyHidden = require("../VisuallyHidden/VisuallyHidden");
var _ChipSpinner = require("./ChipSpinner.styles");
var _excluded = ["loadingVoiceOver"];
/**
 * An internal spinner created for `AssistChip`. Applying the `aria-live` and `aria-atomic`
 * attributes here isn't to spec since this element is added dynamically. However,
 * for now, it works better in NVDA and Talkback than applying these attributes to
 * a wrapper component.
 *
 * @related ['Spinner']
 * @since 8.97.0
 */
var ChipSpinner = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var loadingVoiceOver = _ref.loadingVoiceOver,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_ChipSpinner.StyledChipSpinner, (0, _extends2.default)({
    ref: forwardedRef
  }, rest), /*#__PURE__*/_react.default.createElement(_Spinner.Spinner, {
    size: "xs"
  }), /*#__PURE__*/_react.default.createElement("span", {
    "aria-live": "polite",
    "aria-atomic": "false"
  }, /*#__PURE__*/_react.default.createElement(_VisuallyHidden.VisuallyHidden, null, loadingVoiceOver)));
});
exports.ChipSpinner = ChipSpinner;
ChipSpinner.displayName = 'ChipSpinner';
ChipSpinner.propTypes = {
  /**
   * The text that will be announced to screen readers when the chip changes to
   * its loading state. Defaults to "loading". Text is `VisuallyHidden`.
   *
   * Don't include the chip's label text in `loadingVoiceOver` because some assistive
   * technologies will, by default, read the label text after the `loadingVoiceOver` text.
   */
  loadingVoiceOver: _propTypes.default.string
};
ChipSpinner.defaultProps = {
  loadingVoiceOver: 'Loading'
};